export enum InsightType {
    CLAUSE = 'clause',
    DYNAMIC_INSIGHT = 'dynamic_insight',
    KEYDATA = 'keyData',
    CHAT = 'chat',
}
